import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const make = (path: React.ReactNode) =>
    React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
        <svg
            ref={ref}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            {path}
        </svg>
    ));

export const CheckIcon = make(<path d="M5 13l4 4L19 7" />);
export const XIcon = make(<path d="M6 6l12 12M6 18L18 6" />);
export const WarningIcon = make(
    <>
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
    </>
);
export const LightbulbIcon = make(
    <>
        <path d="M9 21h6" />
        <path d="M10 17h4" />
        <path d="M12 3a6 6 0 00-3.6 10.8c.4.3.6.7.6 1.2v1a1 1 0 001 1h4a1 1 0 001-1v-1c0-.5.2-.9.6-1.2A6 6 0 0012 3z" />
    </>
);
export const GiftIcon = make(
    <>
        <polyline points="20 12 20 22 4 22 4 12" />
        <rect x="2" y="7" width="20" height="5" />
        <line x1="12" y1="22" x2="12" y2="7" />
        <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z" />
        <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z" />
    </>
);
export const LockIcon = make(
    <>
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0110 0v4" />
    </>
);
export const SettingsIcon = make(
    <>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33h.01a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z" />
    </>
);
export const ChatIcon = make(
    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
);
export const ClockIcon = make(
    <>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
    </>
);
export const PhoneIcon = make(
    <>
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
        <line x1="12" y1="18" x2="12.01" y2="18" />
    </>
);
export const SparkleIcon = make(
    <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2zm6 10l.8 2.4L21 15l-2.2.6L18 18l-.8-2.4L15 15l2.2-.6L18 12zM6 14l.7 2.1L9 17l-2.3.9L6 20l-.7-2.1L3 17l2.3-.9L6 14z" />
);
export const TargetIcon = make(
    <>
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="6" />
        <circle cx="12" cy="12" r="2" />
    </>
);
export const WalletIcon = make(
    <>
        <path d="M21 12V7H5a2 2 0 010-4h14v4" />
        <path d="M3 5v14a2 2 0 002 2h16v-5" />
        <path d="M18 12a2 2 0 000 4h4v-4z" />
    </>
);
export const ChartLineIcon = make(
    <>
        <polyline points="3 17 9 11 13 15 21 7" />
        <polyline points="14 7 21 7 21 14" />
    </>
);
export const UtensilsIcon = make(
    <>
        <path d="M3 2v7c0 1.1.9 2 2 2h0a2 2 0 002-2V2" />
        <line x1="5" y1="11" x2="5" y2="22" />
        <path d="M17 2v8a2 2 0 01-2 2h-1V2h3z" />
        <line x1="14" y1="12" x2="14" y2="22" />
        <line x1="20" y1="2" x2="20" y2="22" />
    </>
);
export const ScrollIcon = make(
    <>
        <path d="M8 21h12a2 2 0 002-2v-2H10" />
        <path d="M19 17V5a2 2 0 00-2-2H4l1 18a2 2 0 002 2h3" />
    </>
);
export const BoltIcon = make(
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
);
export const StarIcon = make(
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
);
export const StampIcon = make(
    <>
        <rect x="4" y="14" width="16" height="6" rx="1" />
        <path d="M8 14V8a4 4 0 018 0v6" />
        <path d="M2 22h20" />
    </>
);
export const CloseIcon = make(<path d="M6 6l12 12M6 18L18 6" />);

export const TrashIcon = make(
    <>
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1.5 14a2 2 0 01-2 1.8H8.5A2 2 0 016.5 20L5 6" />
        <path d="M10 11v6M14 11v6" />
        <path d="M9 6V4a2 2 0 012-2h2a2 2 0 012 2v2" />
    </>
);
export const SearchIcon = make(
    <>
        <circle cx="11" cy="11" r="7" />
        <line x1="20" y1="20" x2="16" y2="16" />
    </>
);
export const CameraIcon = make(
    <>
        <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" />
        <circle cx="12" cy="13" r="4" />
    </>
);
export const RefreshIcon = make(
    <>
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
    </>
);
export const WifiOffIcon = make(
    <>
        <line x1="1" y1="1" x2="23" y2="23" />
        <path d="M16.72 11.06A10.94 10.94 0 0119 12.55" />
        <path d="M5 12.55a10.94 10.94 0 015.17-2.39" />
        <path d="M10.71 5.05A16 16 0 0122.58 9" />
        <path d="M1.42 9a15.91 15.91 0 014.7-2.88" />
        <path d="M8.53 16.11a6 6 0 016.95 0" />
        <line x1="12" y1="20" x2="12.01" y2="20" />
    </>
);
export const DownloadIcon = make(
    <>
        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
    </>
);
export const PrinterIcon = make(
    <>
        <polyline points="6 9 6 2 18 2 18 9" />
        <path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2" />
        <rect x="6" y="14" width="12" height="8" />
    </>
);
export const MailIcon = make(
    <>
        <path d="M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z" />
        <polyline points="22 6 12 13 2 6" />
    </>
);
export const CreditCardIcon = make(
    <>
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
    </>
);
export const CashIcon = make(
    <>
        <rect x="2" y="6" width="20" height="12" rx="2" />
        <circle cx="12" cy="12" r="2.5" />
        <path d="M6 12h.01M18 12h.01" />
    </>
);
export const TicketIcon = make(
    <>
        <path d="M3 7v4a2 2 0 010 4v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 010-4V7a2 2 0 00-2-2H5a2 2 0 00-2 2z" />
        <line x1="9" y1="5" x2="9" y2="19" strokeDasharray="2 2" />
    </>
);
export const SunIcon = make(
    <>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </>
);
export const MoonIcon = make(<path d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z" />);
export const HandshakeIcon = make(
    <>
        <path d="M11 17l-5-5 1-1a2.83 2.83 0 014 0l1 1 1-1a2.83 2.83 0 014 0l1 1-5 5z" />
        <path d="M16 7l2 2 2-2" />
        <path d="M4 7l2 2 2-2" />
    </>
);
export const ShoppingBagIcon = make(
    <>
        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <path d="M16 10a4 4 0 01-8 0" />
    </>
);
export const SmartphoneIcon = make(
    <>
        <rect x="5" y="2" width="14" height="20" rx="2" />
        <line x1="12" y1="18" x2="12.01" y2="18" />
    </>
);
export const WaveIcon = make(
    <>
        <path d="M3 12h2l2 6 4-12 4 12 2-6h4" />
    </>
);
export const FlaskIcon = make(
    <>
        <path d="M10 2v6L4.5 19a2 2 0 001.7 3h11.6a2 2 0 001.7-3L14 8V2z" />
        <line x1="9" y1="2" x2="15" y2="2" />
    </>
);
export const ConfettiIcon = make(
    <>
        <path d="M5 17l4-4 4 4-4 4z" />
        <path d="M13 5l4 4-4 4-4-4z" />
        <circle cx="19" cy="5" r="1.5" fill="currentColor" />
        <circle cx="5" cy="5" r="1.5" fill="currentColor" />
        <circle cx="19" cy="19" r="1.5" fill="currentColor" />
    </>
);
